var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowsCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06 2.707L4.355 2 2 4.354l2.354 2.353L5.06 6 3.914 4.854h5.793a2.5 2.5 0 012.5 2.5h1a3.5 3.5 0 00-3.5-3.5H3.914l1.147-1.147zM11.854 12.646l.707.707L14.914 11l-2.353-2.354-.707.708L13 10.5H8.207a2.5 2.5 0 01-2.5-2.5h-1a3.5 3.5 0 003.5 3.5H13l-1.146 1.146z",
    fill: "#000"
  })));
}
export default SvgIconArrowsCircle;